import { TypeComponentNoti } from "@/enums/enums";
import { i18n } from "@/i18n";

export function HandlerHttpResponseForAuthenticationService(
  response: any,
  fnHandlerResponseSuccess: any,
  fnHandlerExceptionDefault: any,
  context: any
) {
  return new Promise<void>(async (resolve) => {
    try {
      if (typeof fnHandlerResponseSuccess !== "function") {
        throw new Error("fnHandlerResponseSuccess must be a function.");
      }
      if (typeof fnHandlerExceptionDefault !== "function") {
        throw new Error("fnHandlerExceptionDefault must be a function.");
      }

      const { status, data } = response;

      // สำหรับ Authentication Service ที่ไม่มี responseCode
      if (status?.IsSuccess() && data?.response) {
        await fnHandlerResponseSuccess(response);
      } else if (status?.IsSuccess() && data?.exception) {
        const { exception } = data;
        await fnHandlerExceptionDefault(exception);
      } else {
        await fnHandlerExceptionDefault(null);
        context.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: `${i18n.t("Something_Wrong")} Status Code : ${response.status}`,
            typeMessage: TypeComponentNoti.Error,
          },
          { root: true }
        );
      }
      resolve();
    } catch (error) {
      context.dispatch("Loading/IsLoading", true, { root: true });
      await fnHandlerExceptionDefault(null);

      console.error("HandlerHttpResponseForAuthenticationService caught an error:", error);
      resolve();
    }
  });
}
